module.exports = __webpack_public_path__ + "static/media/navigation_flow_20th_aug.94a898e3.jpg";